import { render, staticRenderFns } from "./account-balance-histories.pug?vue&type=template&id=b608e638&scoped=true&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./account-balance-histories.scss?vue&type=style&index=0&id=b608e638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b608e638",
  null
  
)

export default component.exports